const NAMESPACE = "cancelResendEnvelopeDialog";

const KEYS = {
    resendESignaturesSubheader: "resendESignaturesSubheader",
    noDocumentsResendableMsg: "noDocumentsResendableMsg",
    resendESignaturesInfoMsg: "resendESignaturesInfoMsg",
    resendESignaturesPreviewLabel: "resendESignaturesPreviewLabel",
    resendLimitationsNote: "resendLimitationsNote",
    resendLimitationsHelpMsg: "resendLimitationsHelpMsg",
    missingContactInfoErrorMsg: "missingContactInfoErrorMsg",
    otherOptionsBtnLabel: "otherOptionsBtnLabel",
    hideOptionsBtnLabel: "hideOptionsBtnLabel",
    resendBtnLabel: "resendBtnLabel",
    notificationsResentMsg: "notificationsResentMsg",
    cancelESignaturesSubheader: "cancelESignaturesSubheader"
};

const MESSAGES = {
    [KEYS.resendESignaturesSubheader]: {
        value: "Resend eSignature Notifications",
        comment: "Section subheader for resending eSignature notifications"
    },
    [KEYS.noDocumentsResendableMsg]: {
        value: "No documents are eligible to be resent. You must wait 15 minutes between attempts to resend eSignature notifications.",
        comment: "Message that displays to the user if no notifications can be resent"
    },
    [KEYS.resendESignaturesInfoMsg]: {
        value: "If one or more of the eSignature signatories did not receive the notification email from DocuSign, use this dialog to resend it. If you need to correct the contact info of a signatory, close this dialog, update the relevant contact info on the form, and return to this dialog.",
        comment: "Message describing to the user what will happen if they resend notifications"
    },
    [KEYS.resendESignaturesPreviewLabel]: {
        value: "The following documents will be resent to the specified recipients:",
        comment:
            "Label for the section that shows updated contact info for any recipients that will be resent notifications"
    },
    [KEYS.resendLimitationsNote]: {
        value: "Note that it may not be possible to resend all documents to all recipients at this time.",
        comment: "Note explaining that there are limitations to resending notifications"
    },
    [KEYS.resendLimitationsHelpMsg]: {
        value: "You must wait 15 minutes between attempts to resend eSignature notifications. You cannot resend notifications or correct contact info for signatories that have already signed. You cannot resend notifications for envelopes where all recipients have signed. In those cases, you must cancel the eSignature request and send a new request.",
        comment: "Help text explaining the detailed limitations on resending notifications"
    },
    [KEYS.missingContactInfoErrorMsg]: {
        value: "Unable to resend eSignature notifications: missing contact info for at least one signatory.",
        comment:
            "Error message when the user tires to resend notifications while contact info is missing for some signatory"
    },
    [KEYS.otherOptionsBtnLabel]: {
        value: "Other Options",
        comment: "Label for button to show options other than resending notifications"
    },
    [KEYS.hideOptionsBtnLabel]: {
        value: "Hide",
        comment: "Label for button to hide options other than resending notifications"
    },
    [KEYS.resendBtnLabel]: {
        value: "Resend Notifications",
        comment: "Label for button to resend notifications"
    },
    [KEYS.notificationsResentMsg]: {
        value: "Notifications Resent!",
        comment: "Text indicating that notifications have been resent"
    },
    [KEYS.cancelESignaturesSubheader]: {
        value: "Cancel eSignature Request",
        comment: "Subheader for section where user can choose to cancel the eSignature request"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
